import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { addVendor } from "./Vendor.action";
import { setHeading } from "../../../accounts/account.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import _ from "lodash";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import Select from "react-select";


const AddVendor = (props) => {
  const [vendorName, setVendorName] = useState();
  const [vendorCnic, setVendorCnic] = useState();
  const [vendorPhone, setVendorPhone] = useState();
  const [vendorAddress, setVendorAddress] = useState();
  const [vendorType, setVendorType] = useState();
  const [company, setCompany] = useState();

  function uploadVendor() {
    props.addVendor({
      vendorName: vendorName,
      vendorPhone: vendorPhone,
      vendorAddress: vendorAddress,
      vendorCnic: vendorCnic,
      vendorType: vendorType,
      company: company,
    },
      showSuccessAlert,
      showErrorAlert,
    );
    setVendorName("")
    setVendorCnic("")
    setVendorPhone("")
    setVendorAddress("")
    setCompany("")
    setVendorType("")
  }

  let vendorTypeData = [
    {
      id: "Internal",
      type: "Internal",
    },
    {
      id: "External",
      type: "External",
    },
  ];
  const handleChangeRoll = (selectedOption) => {
    setVendorType(selectedOption.label);
  };
  const vendorTypeList = vendorTypeData.map((x) => {
    let data = { value: x.id, label: x.type };
    return data;
  });

  useEffect(() => {
    props.setHeading("Add Vendor");
  }, []);

  return (
    <>
      {props.isAddingVendor ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana" >
                <Form.Label><b>Vendor Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Vendor Name"
                  onChange={(e) => setVendorName(e.target.value)} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana" >
                <Form.Label><b>Vendor Phone *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Vendor Phone"
                  value={vendorPhone}
                  onChange={(e) => setVendorPhone(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana" >
                <Form.Label><b>Vendor CNIC </b></Form.Label>
                <Form.Control
                  type="Number"
                  placeholder="Vendor CNIC"
                  onChange={(e) => { setVendorCnic(e.target.value) }} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana" >
                <Form.Label><b>Vendor Address *</b></Form.Label>
                <Form.Control
                  type="text"
                  value={vendorAddress}
                  placeholder="Vendor Address"
                  onChange={(e) => setVendorAddress(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Type *</b></Form.Label>
                <Select
                  placeholder="Select Type"
                  onChange={handleChangeRoll}
                  options={vendorTypeList}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana" >
                <Form.Label><b>Company *</b></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Company"
                  onChange={(e) => setCompany(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>

          <div className="sendDiv">
            {_.isEmpty(vendorName) || _.isEmpty(vendorPhone) || _.isEmpty(vendorAddress) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={uploadVendor}> SAVE</Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    addVendor: (data, showSuccessAlert, showErrorAlert) => dispatch(addVendor(data, showSuccessAlert, showErrorAlert)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  isAddingVendor: state.VendorReducer.isAddingVendor,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddVendor);
